import { Avatar, ListItemButton, Typography } from '@mui/material'
import { ReactNode } from 'react'

import { useStyles } from './styles'
import { IImpactBaseWithId, IStepAccountsBaseWithId } from 'src/types'
import { TableRelationIcon } from '../table-relation-icon'

interface IProps {
  isRound?: boolean
  active?: boolean
  image: string
  title: string
  locationName?: string | null
  subtitle?: string | null
  additionalInfo?: ReactNode
  handleClick: () => void
  conectedIcons?: IImpactBaseWithId[]
  fullWidth?: boolean
  showAccountInfo?: boolean
  conectedAccount?: IStepAccountsBaseWithId | null
  aiGenerated?: boolean
}

export const AssociationsListItem = (props: IProps) => {
  const classes = useStyles({
    isRound: props.isRound,
    fullWidth: props.fullWidth,
    showAccountInfo: props.showAccountInfo && !!props.conectedAccount?.account,
  })

  return (
    <ListItemButton
      className={`${classes.item} ${props.aiGenerated && classes.bgAiGenerated} ${props.aiGenerated && props.active ? classes.borderActiveAiGenerated : props.active ? classes.borderActive : classes.borderInactive}`}
      // sx={{ backgroundColor: 'red !important' }}
      onClick={props.handleClick}
    >
      <Avatar className={classes.icon} src={props.image} alt={props.title} />
      <div>
        <Typography className={classes.title}>{props.title}</Typography>
        {props.locationName && (
          <Typography className={classes.locationName}>{props.locationName}</Typography>
        )}
        <Typography variant="body2" textOverflow="ellipsis" className={classes.subtitle}>
          {props.subtitle}
        </Typography>
        {props.additionalInfo && <>{props.additionalInfo}</>}
        {props.showAccountInfo && props.conectedAccount?.account && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              paddingTop: '5px',
            }}
          >
            <img
              loading="lazy"
              alt={props.conectedAccount.account.account_holder}
              src={props.conectedAccount.account.image_small || props.conectedAccount.account.image}
              style={{
                width: 30,
                height: 30,
                objectFit: 'cover',
                borderRadius: '50%',
              }}
            />
            <Typography variant="body2" textOverflow="ellipsis" className={classes.subtitle}>
              {props.conectedAccount.account.account_holder}
            </Typography>
          </div>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginLeft: 'auto',
          flexWrap: 'wrap',
          // maxWidth: '95px',
        }}
      >
        {props.conectedIcons &&
          props.conectedIcons.map((impact) => {
            return (
              <TableRelationIcon
                title={impact.name}
                subtitle={'#' + impact.code}
                key={impact.id}
                icon={impact.image_small || impact.image}
                iconAlt={impact.name}
              />
            )
          })}
      </div>
    </ListItemButton>
  )
}
